import { styled } from '@mui/material';
import { Header } from '../Header';
import { Outlet } from 'react-router-dom';
import { useBreakpoints } from '../../hooks/useBreakpoints';
import { useAuth } from '@frontend/features/auth/hooks/useAuth';
import { PrivateLogin } from '@frontend/features/auth/components/PrivateLogin';
import { useEffect, useState } from 'react';
import { HotelSearchContextProvider } from '@frontend/features/hotel/components/Availability/Search/HotelSearchContext';
import { FLIGHT_SEARCH_UNDER_HEADER_HEIGHT, HOTEL_SEARCH_UNDER_HEADER_HEIGHT } from '../../constants/layout';

interface LayoutProps {
  noLargeDownHeader?: boolean;
}

const Holder = styled("div")<{ isOpen: boolean; heightValue: number }>(({ theme, isOpen,heightValue }) => ({
  backgroundColor: theme.palette.background.paper,
  transition: "margin-top 0.4s",
  marginTop: isOpen ? heightValue : "0px",
}));

export const Layout = ({ noLargeDownHeader }: LayoutProps) => {
  const { isLargeDown } = useBreakpoints();
  const [toReturn, setToReturn] = useState<null | JSX.Element>(null);
  const { isAuthenticated } = useAuth();
  const [isHotelSearchOpen, setIsHotelSearchOpen] = useState(false);
  const [isFlightsSearchOpen, setIsFlightsSearchOpen] = useState(false);

  useEffect(() => {
    const handler = setTimeout(() => {
      setToReturn(<PrivateLogin />);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [setToReturn]);

  if (isAuthenticated) {
      return (
        <HotelSearchContextProvider>
          <Holder isOpen={isHotelSearchOpen || isFlightsSearchOpen} heightValue={ isHotelSearchOpen ? HOTEL_SEARCH_UNDER_HEADER_HEIGHT : FLIGHT_SEARCH_UNDER_HEADER_HEIGHT}>
            {isLargeDown && noLargeDownHeader ? undefined : <Header onOpenHotelSearch={setIsHotelSearchOpen} onOpenFlightsSearch={setIsFlightsSearchOpen} />}
            <Outlet />
          </Holder>
        </HotelSearchContextProvider>
      );
  }

  return toReturn;
};
